import LibraryBoardMembership from "../board-memberships/LibraryBoardMembership";

export default function LibraryBoardDetails() {
    return (
      <div>
      <div className="government-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Library Board</h2>
        </div>
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines ">
            <div className="mb-960-col-50p left-side-col-50p">
            <h4>Meetings</h4>
                <ul>
                  <li>7:00 p.m.</li>
                  <li>2nd Monday of the month</li>
                  <li>
                    <a href="https://maps.app.goo.gl/d1yBnPNq7T2yWGBA8">
                      <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Library
                      <br />
                      300 N. Pennsylvania Ave.
                      <br />
                      Morrisville, PA 19067
                    </a>
                    <br />
                  </li>
                  <li>
                  Meeting held in the lower level
                  </li>
                </ul>
                <h4>Composition</h4>
                <ul>
                  <li>7 Members</li>
               
     <li>3 year terms</li>
                  <li>Terms expired first day of the month</li>
                </ul>   

                {/*Accordion Start*/}
              <div className="container accordion-container">
                <div className="accordion" id="councilMtgAccordion">
                   {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBoardApply">
                        <div>
                          <i className="fa-solid fa-person-circle-plus fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Apply To Join The Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBoardApply" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/*Accordion Finish*/} 
              </div>
  
              <div className="mb-960-col-50p">
                <div className="council-members">
                  <LibraryBoardMembership/>
              
                </div>
              </div>
            </div>
          </div>
          <div className="page-footer bottom-cap-outlines">&nbsp;</div>
          <div className="gap-spacer"></div>
        </div>
      </div>
    )
  }